import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { SITE } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const CtaFinal = () => (
  <section
    className="relative noise-overlay"
    style={{ background: "linear-gradient(135deg, #0A2540 0%, #1E4FA8 100%)" }}
    data-testid="final-cta-section"
  >
    <div className="max-w-[720px] mx-auto px-6 py-24 lg:py-32 text-center">
      <Reveal>
        <p className="micro-label mb-4" style={{ color: "rgba(255,255,255,0.7)" }}>Prêt à commencer</p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] text-white">
          Votre façade mérite mieux qu'un devis vague.
        </h2>
        <p className="mt-5 text-lg text-white/85">Un vrai devis, sur place, sous 48h. Sans engagement.</p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/devis" className="btn-base btn-white w-full sm:w-auto" data-testid="final-cta-devis-btn">
            Demander mon devis
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
          <a href={SITE.phoneHref} className="btn-base btn-outline-white w-full sm:w-auto tnum" data-testid="final-cta-phone-btn">
            <Phone size={18} aria-hidden="true" />
            {SITE.phone}
          </a>
        </div>
        <p className="mt-6 text-[13px] text-white/60">Devis gratuit sous 48h</p>
      </Reveal>
    </div>
  </section>
);
